import { type FrameValue, animated } from '@react-spring/web'
import cx from 'classnames'

interface ConfigurationStepPreviewProps {
  stepNumber: number
  title: string
  value?: string
  error?: string
  placeholder?: string
  opacity?: number | FrameValue<number>
  onClick: () => void
  className?: string
  valueClassName?: string
}

const ConfigurationStepPreview = ({
  stepNumber,
  title,
  value,
  error,
  placeholder,
  opacity = 1,
  onClick,
  className,
  valueClassName,
}: ConfigurationStepPreviewProps) => {
  return (
    <animated.div
      onClick={onClick}
      className={cx(
        'flex items-center py-5 md:px-5 select-none hover:cursor-pointer border-b md:hover:bg-gray-50 transition-colors',
        className,
      )}
      style={{
        opacity,
      }}
    >
      <div className="flex items-center space-x-3">
        <div className="grow-0 shrink-0 flex justify-center content-center items-center w-[37px] h-[37px] bg-white border border-black rounded-full font-medium text-center">
          {stepNumber}
        </div>

        <p className="flex flex-col justify-center h-full">
          <span>{title}</span>

          {!!error && <span className="text-error">{error}</span>}

          {!error && value && (
            <span className={cx('text-gray-700', valueClassName)}>{value}</span>
          )}

          {!error && !value && !!placeholder && (
            <span className="italic text-gray-700">{placeholder}</span>
          )}
        </p>
      </div>
    </animated.div>
  )
}

export default ConfigurationStepPreview
